export default {
  valueType: 'password',
  FormItemProps: {
    label: '密码',
    rules: [
      {
        pattern: /^[^\s]*$/,
        message: '密码不能有空格',
      },
    ],
    style: {}
  },
  ControlProps: {
    prefix: "", // 带有前缀图标的 input
    suffix: "", // 带有后缀图标的 input
    disabled: false,
    maxLength: null,
    placeholder: "请输入密码",
    allowClear: true,
    style: {}
  },
}

